import * as connectionBackend from '@/api/connection'
import { common as commonBackend } from '@/api'
import Paginator from '@/models/Paginator'
import Company from '@/models/Company'
import CompanyOverview from '@/models/CompanyOverview'
import find from 'lodash/find'

export default {
  
  namespaced: true,

  state: {
    entityName: '',
    connectWithEntity: {},
    company: new Company,
    companies: new Paginator,
    companiesList: [],
    overview: new CompanyOverview
  },

  mutations: {
    setEntityName: (state, name) => state.entityName = name,
    clearEntityName: (state) => state.entityName = '',
    setConnectWithEntity: (state, payload) => state.connectWithEntity = payload,
    setOverview: (state, payload) => state.overview = payload,
    clearOverview: (state) => state.overview = new CompanyOverview,
    setCompany: (state, payload) => state.company = payload,
    clearCompany: (state) => state.company = new Company,
    setCompanies: (state, payload) => state.companies = payload,
    setCompaniesList: (state, payload) => state.companiesList = payload,
    setLegalName: (state, payload) => state.company.legal_name = payload,
    setTradingName: (state, payload) => state.company.trading_name = payload,
    setRegistrationNumber: (state, payload) => state.company.registration_number = payload,
    setTelephone: (state, payload) => state.company.telephone = payload,
    setVatNumber: (state, payload) => state.company.vat_number = payload,
    setLogo: (state, payload) => state.company.logo_url = payload,
    toggleCreateUserAccount: (state) => state.company.create_user = !state.company.create_user,
    setUser: (state, payload) => state.company.user = payload,
    setUserFullName: (state, payload) => state.company.user.full_name = payload,
    setUserEmail: (state, payload) => state.company.user.email = payload,
    setUserMobile: (state, payload) => state.company.user.mobile = payload,
  },

  actions: {
    checkForExistence: ({ state }) => new Promise((resolve, reject) => {
      connectionBackend.checkForExistence(state.entityName, resolve, reject)
    }),
  
    loadCompaniesPaginated: ({ commit }, payload) => new Promise((resolve, reject) => {
      commonBackend.loadPath(payload, response => {
        commit('setCompanies', response.data)
        resolve()
      }, reject)
    }),
  
    loadCompaniesList: ({ commit }) => new Promise((resolve, reject) => {
      connectionBackend.loadList(response => {
        commit('setCompaniesList', response.data)
        resolve()
      }, reject)
    }),
  
    loadCompany: ({ commit }, companyId) => new Promise((resolve, reject) => {
      connectionBackend.loadCompany(companyId, response => {
        commit('setCompany', response.data)
        resolve()
      }, reject)
    }),
  
    loadOverview: ({ commit }, companyId) => new Promise((resolve, reject) => {
      connectionBackend.loadOverview(companyId, ({ data }) => {
        commit('setOverview', data)
        resolve()
      }, reject)
    }),
  
    createConnection: ({ state }) => new Promise((resolve, reject) => {
      connectionBackend.createConnection(state.company, resolve, reject)
    }),
  
    updateCompany: ({ state }) => new Promise((resolve, reject) => {
      connectionBackend.updateCompany(state.company, resolve, reject)
    }),
  
    createUser: ({ state }, user) => new Promise((resolve, reject) => {
      connectionBackend.createUser({
        company: state.company.id,
        user
      }, response => {
        resolve(response.data)
      }, reject)
    }),
  
    uploadLogo: ({ state, commit }, file) => new Promise((resolve, reject) => {
      connectionBackend.uploadLogo({
        company: state.company.id,
        file
      }, response => {
        commit('setLogo', response.data)
        resolve()
      }, reject)
    }),
  
    allowAbility: ({ state }, ability) => new Promise((resolve, reject) => {
      connectionBackend.allowAbility({
        company: state.company.id,
        ability
      }, resolve, reject)
    }),
  
    disallowAbility: ({ state }, ability) => new Promise((resolve, reject) => {
      connectionBackend.disallowAbility({
        company: state.company.id,
        ability
      }, resolve, reject)
    })
  },

  getters: {
    isControlled: state => state.company.controlled_by_companies.length > 0,
    company: state => state.company,
    controlledByCurrentCompany(state, getters, rootState) {
      return rootState.auth.user.primary_company && find(
        state.company.controlled_by_companies,
        company => company.id === rootState.auth.user.primary_company.id
      )
    }
  }
}
